import { AddressByCompanyBuyerRequest } from "@/main/models/request";
import { AddressByBodyshopResponse } from "@/main/models/response";

export enum BillingAddressTypes {
	GET_BILLING_ADDRESS = "@billingAddress/GET_BILLING_ADDRESS",
	SAVE_BILLING_ADDRESS = "@billingAddress/SAVE_BILLING_ADDRESS",
	RESET_REDUCER_BILLING_ADDRESS = "@billingAddress/RESET_REDUCER_BILLING_ADDRESS",
}

export interface BillingAddressState {
	readonly billingAddress: {
		data: AddressByBodyshopResponse[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetBillingAddress {
	type: typeof BillingAddressTypes.GET_BILLING_ADDRESS;
	payload: {
		request: AddressByCompanyBuyerRequest;
	};
}

export interface SaveBillingAddress {
	type: typeof BillingAddressTypes.SAVE_BILLING_ADDRESS;
	payload: {
		data: AddressByBodyshopResponse[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerBillingAddress {
	type: typeof BillingAddressTypes.RESET_REDUCER_BILLING_ADDRESS;
}

export type BillingAddressActionTypes = GetBillingAddress | SaveBillingAddress | ResetReducerBillingAddress;
